import {combineReducers} from 'redux';
import authReducer from './authReducer';
import appReducer from "./appReducer";
import loadingReducer from "./loadingReducer";
import notificationReducer from "./notificationReducer";
import confirmReducer from "./confirmReducer";

import storage from 'redux-persist/lib/storage';
import {persistReducer} from 'redux-persist';

const persistConfig = {
    key: 'root',
    storage,
};
const persistAuthReducer = persistReducer(persistConfig, authReducer);


const rootReducer = combineReducers({
    auth: persistAuthReducer,
    app: appReducer,
    loading: loadingReducer,
    notification: notificationReducer,
    confirm: confirmReducer
})

export default rootReducer;
